module.exports = __webpack_public_path__ + "static/media/banner1.8d8c6be9.png";